import { init, Options } from './core'

function install(Vue: any, options: Options) {
  console.log('webtracker vue init', options)
  init(options)
}

export default {
  install
}

export * from './core'
